const url = import.meta.env.VITE_APP_API_TRADE
export default {
    actions: {
        createExchange: async ({ commit, getters, dispatch }, data) => {
            return dispatch("fetchAuth", {
                url: `${url}/exchange/add`,
                option: {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(data)
                },
                action: {name: "createExchange", data: data},
            }).then(
                result => {
                    if(result.code === 200)
                        dispatch('fetchUserExchangeList')
                    return result
                },
            )
        },
        fetchExchangeSettings: async ({ commit, getters }) => {
            try {
                const resJson = await fetch(`${url}/exchange/settings`)
                const res = await resJson.json()
                if (res.code === 200) {
                    commit('SET_EXCHANGE_LIST', res.data.items)
                }
                return res
            } catch (e) {
                return []
            }
        },
        fetchUserExchangeList: async ({ commit, dispatch }) => {
            commit('SET_USER_EXCHANGE_LIST_LOADING_STATUS', 'loading')

            return dispatch("fetchAuth", {
                url: `${url}/exchange/my-list`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "fetchUserExchangeList", data: {}},
            }).then(
                result => {
                    if(result.data.items) {
                        commit('SET_USER_EXCHANGE_LIST_LOADING_STATUS', 'success')
                        commit('SET_USER_EXCHANGE_LIST', result.data.items)
                    } else  {
                        commit('SET_USER_EXCHANGE_LIST_LOADING_STATUS', 'error')
                    }
                },
                error => {
                    commit('SET_USER_EXCHANGE_LIST_LOADING_STATUS', 'error')
                }
            )
        },

    },
    mutations: {
        SET_EXCHANGE_LIST(state, list) {
            state.exchangeList = list
        },
        SET_USER_EXCHANGE_LIST(state, items) {
            state.userExchangeList = items
        },
        SET_USER_EXCHANGE_LIST_LOADING_STATUS(state, status) {
            state.userExchangeListLoadingStatus = status
        },
    },
    state: {
        exchangeList: null,
        userExchangeListLoadingStatus: 'loading',
        userExchangeList: [],
    },
    getters: {
        getExchangeList:(state) => state.exchangeList,
        getUserExchangeList:(state) => state.userExchangeList,
        getUserExchangeListLoadingStatus:(state) => state.userExchangeListLoadingStatus,
    },
}